import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Const } from '../../static/const';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  public notificationsSubject = new BehaviorSubject<any[]>([]);
  public hasNewSubject = new BehaviorSubject<boolean>(false);

  public savedNotificationsSubject = new BehaviorSubject<any[]>([]);
  savedNotifications$ = this.savedNotificationsSubject.asObservable();

  viewedNotificationsSubject = new BehaviorSubject<string[]>([]);
  viewedNotifications$ = this.viewedNotificationsSubject.asObservable();

  constructor(private http: HttpClient) {}

  /** Get notifications */
  getNotifications(): Observable<any[]> {
    return this.notificationsSubject.asObservable();
  }

  /** To Get all Previously Saved Notifications */
  getSavedNotifications(data) {
    const url = Const.connectionUrl + '/api/get_save_notifications';

    return this.http.post(url, data);
  }

  /** To Get update viewed notification status */
  getUpdateNotificationViewStatus(data) {
    const url = Const.connectionUrl + '/api/update_notificationstatus';

    return this.http.post(url, data);
  }

  /** Check if there are new notifications */
  hasNewNotifications(): Observable<boolean> {
    return this.hasNewSubject.asObservable();
  }

  /** Add a new notification */
  // addNotification(notification: any): void {
  //   const currentNotifications = this.notificationsSubject.getValue();
  //   this.notificationsSubject.next([...currentNotifications, notification]);
  //   this.hasNewSubject.next(true);
  // }

  addNotification(notification: any): void {
    const currentNotifications = this.notificationsSubject.getValue();
    const updatedNotifications = [...currentNotifications, notification];
    this.notificationsSubject.next(updatedNotifications);
    this.savedNotificationsSubject.next(updatedNotifications); // Add this line
    this.hasNewSubject.next(true);
  }

  /** Mark notifications as read */
  markAsRead(): void {
    this.hasNewSubject.next(false);
  }

  markAsViewed(summary: string) {
    const current = this.viewedNotificationsSubject.getValue();
    if (!current.includes(summary)) {
      this.viewedNotificationsSubject.next([...current, summary]);
    }
  }

  /** Clear all notifications */
  clearNotifications(): void {
    this.notificationsSubject.next([]);
    this.hasNewSubject.next(false);
  }
}
